import React from "react";
import { Box, Button, ButtonGroup } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

interface ActionButtonsProps {
  onEdit: () => void;
  onDelete: () => void;
  onBack: () => void;
}

export default function ActionButtons({
  onEdit,
  onDelete,
  onBack,
}: ActionButtonsProps) {
  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
      <ButtonGroup variant="outlined" aria-label="action buttons">
        <Button
          onClick={onBack}
          startIcon={<ArrowBackIcon />}
          sx={{
            backgroundColor: "rgba(81, 35, 132, 1)",
            color: "#fff",
            "&:hover": {
              backgroundColor: "rgba(81, 35, 132, 0.9)",
            },
          }}
        >
          Back to List
        </Button>

        <Button
          onClick={onEdit}
          variant="outlined"
          startIcon={<EditIcon />}
          sx={{
            color: "rgba(81, 35, 132, 1)",
            borderColor: "rgba(81, 35, 132, 1)",
            "&:hover": {
              borderColor: "rgba(81, 35, 132, 0.8)",
              backgroundColor: "rgba(81, 35, 132, 0.05)",
            },
          }}
        >
          Edit
        </Button>

        <Button
          onClick={onDelete}
          color="error"
          variant="contained"
          startIcon={<DeleteIcon />}
        >
          Delete
        </Button>
      </ButtonGroup>
    </Box>
  );
}
